import React from 'react';
import Modal from '../Modal/Modal';

/**
 * Specialized confirm/destructive-action modal.
 * Simpler API than the generic Modal.
 *
 * @param {object}      props
 * @param {boolean}     props.open
 * @param {() => void}  props.onClose
 * @param {() => void|Promise<void>} props.onConfirm
 * @param {string}      [props.title='Are you sure?']
 * @param {string}      [props.description]
 * @param {string}      [props.confirmText='Confirm']
 * @param {string}      [props.cancelText='Cancel']
 * @param {boolean}     [props.danger=true]
 * @param {boolean}     [props.loading]
 */
const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = true,
  loading,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
    size="sm"
    confirmText={confirmText}
    cancelText={cancelText}
    danger={danger}
    loading={loading}
  >
    {description && <p style={{ margin: 0, color: 'var(--text-secondary)' }}>{description}</p>}
  </Modal>
);

export default ConfirmModal;
